
import Actions from './actions';
import Button from '../../../components/form/button.jsx';
import ControlGroup from '../../../components/form/control-group.jsx';
import React from 'react';
import Spinner from '../../../components/form/spinner.jsx';
import Store from './store';
import TextControl from '../../../components/form/text-control.jsx';
import TextareaControl from '../../../components/form/textarea-control.jsx';
import SelectControl from '../../../components/form/select-control.jsx';
import { Recaptcha } from '../../../components';
import { handleLocalStateChange } from '../../../utils/react';

class Form extends React.Component {
  constructor(props) {

    super(props);

    this.input = {};
    this.state = Store.getState();
    this.state.captcha = false;
  }

  componentDidMount() {

    this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

  }

  componentWillUnmount() {

    this.unsubscribeStore();

    Actions.resetStore();
  }

  onStoreChange() {
    this.setState(Store.getState());
  }

  handleSubmit(event) {

    event.preventDefault();
    event.stopPropagation();
    Actions.sendMessage({
      paymentType: this.input.paymentType.value(),
      planType: this.input.planType.value(),
      timeQuantity: this.input.timeQuantity.value(),
      email: this.input.email.value(),
      message: this.input.message.value(),
      captcha: this.state.captcha,
    });
  }

  render() {
    const alerts = [];

    if (this.state.success) {
      alerts.push(
        <div key="success" className="alert alert-success">
          Crypto payment request sent! We&#39;ll be emailing you shortly.<br/><br/>Feel free to sign up for a free Basic plan to explore the CoinMarketCap API in the meantime.
        </div>
      );
    }

    if (this.state.validation.error) {
      //hack customized form error messages to be friendly
      const errorTarget = Object.keys(this.state.validation.hasError)[0];
      let errorMessage = this.state.validation.help[errorTarget];
      if (errorMessage){
        if (errorMessage.indexOf("not allowed to be empty")!==-1){
          errorMessage = "This field is required.";
        } else if (errorMessage.indexOf("must be a valid email")!==-1){
          errorMessage = "A valid email address is required.";
        } else if (errorMessage === '"captcha" must be a string'){
          errorMessage = "Please click the CAPTCHA box above to prove you are not a robot.";
        }
        this.state.validation.help[errorTarget] = errorMessage; // eslint-disable-line
      }
      alerts.push(
        <div key="danger" className="alert alert-danger">
          {this.state.validation.error}
        </div>
      );
    }

    let formElements;

    if (!this.state.success) {
      formElements = <fieldset>
        <SelectControl
          ref={(c) => (this.input.paymentType = c)}
          name="paymentType"
          label="Payment type - Latest market rate USD conversion will be applied"
          hasError={this.state.validation.hasError.paymentType}
          help={this.state.validation.help.paymentType}
          disabled={this.state.loading}
        >
          <option value="Bitcoin">Bitcoin</option>
          <option value="Ethereum">Ethereum</option>
        </SelectControl>

        <SelectControl
          ref={(c) => (this.input.planType = c)}
          name="planType"
          label="What plan would you like to pay for"
          hasError={this.state.validation.hasError.planType}
          help={this.state.validation.help.planType}
          disabled={this.state.loading}
        >
          <option key="1" value="05">Hobbyist Plan - $35/month or $29/month for 12+ months</option>
          <option key="2" value="1">Startup Plan - $95/month or $79/month for 12+ months</option>
          <option key="3" value="2">Standard Plan - $375/month or $299/month for 12+ months</option>
          <option key="4" value="3">Professional Plan - $875/month or $699/month for 12+ months</option>
        </SelectControl>

        <SelectControl
          ref={(c) => (this.input.timeQuantity = c)}
          name="timeQuantity"
          label="How many months would you like to pay for? (mininimum $100)"
          hasError={this.state.validation.hasError.timeQuantity}
          help={this.state.validation.help.timeQuantity}
          disabled={this.state.loading}
          defaultValue="1 year"
        >
          <option key="1" value="1 month">1 month</option>
          <option key="2" value="2 months">2 months</option>
          <option key="3" value="3 months">3 months</option>
          <option key="4" value="6 months">6 months</option>
          <option key="5" value="9 months">9 months</option>
          <option key="6" value="1 year">1 year</option>
          <option key="7" value="2 years">2 years</option>
        </SelectControl>

        <TextControl
          ref={(c) => (this.input.email = c)}
          name="email"
          type="email"
          autocomplete="email"
          label="Email Address for account to apply payment to"
          hasError={this.state.validation.hasError.email}
          help={this.state.validation.help.email}
          disabled={this.state.loading}
          maxlength="256"
        />

        <TextareaControl
          ref={(c) => (this.input.message = c)}
          name="message"
          label="Optionally include a message with your request"
          rows="5"
          hasError={this.state.validation.hasError.message}
          help={this.state.validation.help.message}
          disabled={this.state.loading}
        />

        <ControlGroup
          hasError={this.state.validation.hasError.captcha}
          help={this.state.validation.help.captcha}
        >
          <Recaptcha
            onChange={handleLocalStateChange.bind(this, 'captcha')}
          />
        </ControlGroup>

        <ControlGroup hideLabel={true} hideHelp={true}>
          <Button
            type="submit"
            inputClasses={{ 'btn-primary': true }}
            disabled={this.state.loading} >

            Send request
            <Spinner space="left" show={this.state.loading} />
          </Button>
        </ControlGroup>

      </fieldset>;
    }

    return (
      <section>
        <div className="contact-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
          <h1 className="display-4">Pay with crypto.</h1>
          <p>We currently accept Bitcoin or Ethereum crypto payments with a minimum order size of $100.<br/>Complete the crypto payment request form below and we'll email you with a crypto invoice.</p>
        </div>
        <form className="auth-form" onSubmit={this.handleSubmit.bind(this)} method="post">
          {alerts}
          {formElements}
        </form>
      </section>
    );
  }
}


export default Form;



// WEBPACK FOOTER //
// ./client/pages/main/contactCryptoPayment/form.jsx